import { Box } from '@mui/system';
import MainCard from 'ui-component/cards/MainCard';
import Logo from 'ui-component/Logo';
import { CircularProgress } from '@mui/material';

function SplashScreen() {
    return (
        <MainCard
            border={false}
            content={false}
            sx={{
                ml: 2,
                py: 2,
                display: 'flex',
                justifyContent: 'center',
                height: '100vh',
                width: 1,
                bgcolor: 'transparent',
                position: 'fixed',
                top: 0,
                left: 0
            }}
        >
            <Box
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                sx={{ height: '100%', width: 1, flexDirection: 'column' }}
            >
                <Logo />
                <CircularProgress sx={{ mt: 5 }} />
            </Box>
        </MainCard>
    );
}

export default SplashScreen;
